import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  fileContainers: [],
  getFileContainersStatus: IDLE,

  insuredRiskFileContainers: [],
  getInsuredRiskFileContainersStatus: IDLE
};

const slice = createSlice({
  name: 'fileContainers',
  initialState,
  reducers: {
    getFileContainers(state) {
      state.getFileContainersStatus = LOADING;
    },
    getFileContainersSucceeded(state, action) {
      state.fileContainers = action.payload;
      state.getFileContainersStatus = SUCCEEDED;
    },
    getFileContainersFailed(state) {
      state.getFileContainersStatus = FAILED;
    },

    getInsuredRiskFileContainers(state) {
      state.getInsuredRiskFileContainersStatus = LOADING;
    },
    getInsuredRiskFileContainersSucceeded(state, action) {
      state.insuredRiskFileContainers = action.payload;
      state.getInsuredRiskFileContainersStatus = SUCCEEDED;
    },
    getInsuredRiskFileContainersFailed(state) {
      state.getInsuredRiskFileContainersStatus = FAILED;
    },

    clearInsuredRiskFileContainers(state) {
      state.insuredRiskFileContainers = [];
      state.getInsuredRiskFileContainersStatus = IDLE;
    }
  }
});

export const {
  getFileContainers,
  getFileContainersSucceeded,
  getFileContainersFailed,
  getInsuredRiskFileContainers,
  getInsuredRiskFileContainersSucceeded,
  getInsuredRiskFileContainersFailed,
  clearInsuredRiskFileContainers
} = slice.actions;

export default slice.reducer;
